<template>
  <div>
    <div class="row">
      <div class="col-12 col-xs-4 col-sm-3 col-md-3 mb-4">
        <div
          class="d-flex"
          style="height: 150px; border: 1px dashed #bbb; border-radius: 6px; flex-wrap: wrap"
        >
          <v-btn
            style="height: auto"
            depressed
            color="grey darken-3"
            class="white--text my-3"
            @click="takePhotoModal = true"
          >
            <i class="fa fa-camera pr-2" />
            {{ $t('orders.takePhotoTooltip') }}
          </v-btn>

          <v-btn
            style="height: auto"
            depressed
            color="blue darken-3"
            class="white--text my-3"
            @click="openExplorer()"
          >
            <i class="fa fa-cloud-upload pr-2" />
            {{ $t('orders.uploadPhotoButton') }}
          </v-btn>

          <!-- input file -->
          <input
            ref="uploadPhotoRef"
            type="file"
            style="position: absolute; visibility: hidden; top: -99999px"
            accept="image/*"
            @input="saveUploadedImage()"
          />
        </div>
      </div>

      <div
        v-if="formData.image"
        class="col-12 col-xs-4 col-sm-3 col-md-3 mb-4"
        style="cursor: pointer; position: relative"
      >
        <img
          :src="formData.image.startsWith('http') ? formData.image : `${$_image_path()}${formData.image}`"
          :alt="$t('columns.image')"
          width="100%"
          height="150px"
          style="border-radius: 4px; object-fit: cover"
          @click="showImage(formData.image, true)"
        >
      </div>

      <div
        class="col-12 col-xs-4 col-sm-3 col-md-3 mb-4"
        v-for="(img,i) in images"
        :key="i"
        style="cursor: pointer; position: relative"
      >
        <img
          :src="img[filenameKey] && img[filenameKey].startsWith('http') ? img[filenameKey] : `${$_image_path()}${img[filenameKey]}`"
          :alt="$t('columns.image')"
          width="100%"
          height="150px"
          style="border-radius: 4px; object-fit: cover"
          @click="showImage(img)"
        >

        <!-- delete button -->
        <button
          type="button"
          class="error pa-2 d-flex align-center"
          style="border-radius: 50%; height: 30px; width: 30px; position: absolute; top: -10px; right: 0px"
          @click="deleteImage(img)"
        >
          <i class="fa fa-trash fa-lg white--text" />
        </button>
      </div>
    </div>

    <!-- Take photo -->
    <take-photo
      :takePhotoModal="takePhotoModal"
      :orderData="formData"
      :url="url"
      :filenameKey="filenameKey"
      :modelFk="modelFk"
      :modelPk="modelPk"
      @close="takePhotoModal = false"
      @photo-saved="getFiles()"
    />

    <!-- Show image -->
    <v-dialog
      v-model="imageDialog"
      width="600"
    >
      <v-card>
        <img
          :src="image && image.startsWith('http') ? image : `${$_image_path()}${image}`"
          alt=""
          width="100%"
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import takePhoto from './takePhoto.vue'
import swal from 'sweetalert'
import { isAllowedImageExtension, ALLOWED_IMAGE_EXTENSIONS } from '../mixins/helpers'

export default {
  components: {
    takePhoto
  },

  props: {
    formData: { type: Object, required: true },
    url: { type: String, default: 'api/order_image' },
    singleStoreUrl: { type: String, default: 'api/order_image/single_upload' },
    filenameKey: { type: String, default: 'order_image' },
    modelFk: { type: String, default: 'order_id_fk' },
    modelPk: { type: String, default: 'order_id' }
  },

  data() {
    return {
      imageDialog: false,
      image: null,
      images: [],
      takePhotoModal: false
    }
  },

  mounted() {
    this.getFiles()
  },

  watch: {
    formData: {
      deep: true,
      handler() {
        this.getFiles()
      }
    }
  },

  methods: {
    openExplorer() {
      this.$refs.uploadPhotoRef.click()
    },

    saveUploadedImage() {
      let file = this.$refs.uploadPhotoRef.files[0]

      if (!isAllowedImageExtension(file.name)) {
        this.$refs.uploadPhotoRef.value = ''
        return swal('', this.$t('orders.unsupportedImageTypeShort', { allowed: ALLOWED_IMAGE_EXTENSIONS.join(', ').toUpperCase() }), 'error')
      }

      if (file.size > 50 * 1024 * 1024) {
        this.$refs.uploadPhotoRef.value = ''
        return swal('', this.$t('orders.fileSizeLimitShort'), 'error')
      }

      let formData = new FormData()
      formData.append(this.filenameKey, file)
      formData.append(this.modelFk, this.formData[this.modelPk])

      let token = localStorage.getItem('access_token')
      let payload = {
        headers: { Authorization: 'Bearer ' + token }
      }

      axios.post(this.singleStoreUrl, formData, payload).then(() => {
        this.getFiles()
      })
    },

    getFiles() {
      let token = localStorage.getItem('access_token')
      let payload = {
        params: { id: this.formData[this.modelPk] },
        headers: { Authorization: 'Bearer ' + token }
      }

      axios.get(this.url, payload).then(res => {
        this.images = res.data
      })
    },

    deleteImage(image) {
      swal({
        title: this.$t('common.areYouSure'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          let payload = {
            headers: { Authorization: 'Bearer ' + token }
          }

          axios.delete(`${this.url}/${image.order_image_id}`, payload).then(() => {
            this.getFiles()
            swal({
              title: this.$t('delivery.deletedTitle'),
              text: '',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          })
        }
      })
    },

    showImage(img, mainImage = false) {
      this.image = mainImage ? img : img[this.filenameKey]
      this.imageDialog = true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/orderImages.vue